<script lang="ts">
  import RoutingControls from './components/RoutingControls.svelte';
  import FilterControls from './FilterControls.svelte';
  import IframeSmartmodel from './components/IframeSmartmodel.svelte';
  import type { SmartmodelMessage } from './components/types/smartmodel-message';
  import type { FilterValue } from './global';
  import FavoritesControls from './components/FavoritesControls.svelte';

  let favoritesList = ['KL-LM-71', 'KL-LM-26'];
  // const appUrl = 'http://localhost:4200';
  const appUrl = 'https://kdlegionowo.dev.smartmodel.pl/pl/';

  const handleSmartModelMessage = (message: CustomEvent<SmartmodelMessage>) => {
    switch (message.detail.receiver) {
      case 'status':
        if (message.detail.data === 'FAVORITES_READY') {
          iframeSmartmodel.sendMessage({
            receiver: 'favorites',
            data: favoritesList,
          });
        }
        break;
      case 'favorites':
        console.log(message.detail.data);
        favoritesList = message.detail.data;
        break;
    }
    console.log(message.detail);
  };

  let iframeSmartmodel: IframeSmartmodel;

  const sendFilterToSmartmodel = (event: CustomEvent<FilterValue>) => {
    console.log(event.detail);
    iframeSmartmodel.sendMessage({ receiver: 'filter', data: event.detail });
  };

  const sendMessageToSmartmodel = (event: CustomEvent<SmartmodelMessage>) => {
    iframeSmartmodel.sendMessage(event.detail);
  };
</script>

<div class="accordion accordion-flush mb-3">
  <div class="accordion-item">
    <h2 class="accordion-header" id="navigationHeading">
      <button
        class="accordion-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navigationControls"
        aria-expanded="true"
        aria-controls="navigationControls">
        Nawigacja
      </button>
    </h2>
    <div id="navigationControls" class="accordion-collapse collapse show" aria-labelledby="navigationHeading">
      <div class="accordion-body">
        <RoutingControls on:navigate="{sendMessageToSmartmodel}" />
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="filterControlsHeading">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#filterControls"
        aria-expanded="false"
        aria-controls="filterControls">
        Filtry
      </button>
    </h2>
    <div id="filterControls" class="accordion-collapse collapse" aria-labelledby="filterControlsHeading">
      <div class="accordion-body">
        <FilterControls on:filterValue="{sendFilterToSmartmodel}" />
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="favoritesControlsHeading">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#favoritesControls"
        aria-expanded="false"
        aria-controls="favoritesControls">
        Ulubione / schowek
      </button>
    </h2>
    <div id="favoritesControls" class="accordion-collapse collapse" aria-labelledby="favoritesControlsHeading">
      <div class="accordion-body">
        <FavoritesControls favorites="{favoritesList}" on:select="{sendMessageToSmartmodel}" />
      </div>
    </div>
  </div>
</div>

<IframeSmartmodel on:iframeMessage="{handleSmartModelMessage}" appUrl="{appUrl}" bind:this="{iframeSmartmodel}" />

<style lang="scss" global>
  @import 'styles/main';
</style>
